<script>
import {config} from "@/config";
export default {
  beforeMount() {
    this.SignOut();
  },
  methods: {
    SignOut() {
      axios.post('./api/odjava/', {withCredentials: true}).then((response) => {
        localStorage.removeItem("User");
        config.User = null;
        config.FullUser = null;
        config.UserLVL =null;
        config.UserID = null;
        config.PwrUser =null;
        this.checkLogin();
      }).catch((error) => {
        localStorage.removeItem("User");
        config.User = null;
        config.FullUser = null;
        config.UserLVL =null;
        config.UserID = null;
        config.PwrUser =null;
        this.$router.push("/Login");
      })
    },
  }
}
</script>
<template></template>